import { Box, useTheme } from '@mui/material';
import { Target, TrendingDown, TrendingUp } from 'lucide-react';
import React from 'react';

interface NewMatchBadgeProps {
    match: number;
    title?: string;
    size?: 'small' | 'medium';
}

export default function New_MatchBadge({ match, title, size = 'medium' }: NewMatchBadgeProps) {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    // Match-basierte Farben und Icons
    const getMatchStatus = () => {
        if (match >= 90)
            return {
                color: theme.palette.success.main,
                icon: Target,
                bg: isDark ? 'rgba(76,175,80,0.15)' : 'rgba(76,175,80,0.1)',
                border: isDark ? 'rgba(76,175,80,0.3)' : 'rgba(76,175,80,0.2)',
            };
        if (match >= 70)
            return {
                color: theme.palette.info.main,
                icon: TrendingUp,
                bg: isDark ? 'rgba(33,150,243,0.15)' : 'rgba(33,150,243,0.1)',
                border: isDark ? 'rgba(33,150,243,0.3)' : 'rgba(33,150,243,0.2)',
            };
        if (match >= 50)
            return {
                color: theme.palette.warning.main,
                icon: TrendingUp,
                bg: isDark ? 'rgba(255,152,0,0.15)' : 'rgba(255,152,0,0.1)',
                border: isDark ? 'rgba(255,152,0,0.3)' : 'rgba(255,152,0,0.2)',
            };
        return {
            color: theme.palette.error.main,
            icon: TrendingDown,
            bg: isDark ? 'rgba(244,67,54,0.15)' : 'rgba(244,67,54,0.1)',
            border: isDark ? 'rgba(244,67,54,0.3)' : 'rgba(244,67,54,0.2)',
        };
    };

    const status = getMatchStatus();
    const IconComponent = status.icon;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                px: 1,
                py: 0.5,
                borderRadius: 1,
                bgcolor: status.bg,
                border: `1px solid ${status.border}`,
                minWidth: size === 'small' ? 50 : 60,
                height: size === 'small' ? 20 : 24,
            }}
            title={title}
        >
            <Box sx={{ color: status.color, display: 'flex' }}>
                <IconComponent size={size === 'small' ? 12 : 14} />
            </Box>
            <Box
                sx={{
                    fontSize: size === 'small' ? '0.7rem' : '0.75rem',
                    fontWeight: 600,
                    color: isDark ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.8)',
                    lineHeight: 1,
                }}
            >
                {match}%
            </Box>
        </Box>
    );
}
